export default __webpack_public_path__ + "static/media/FiveDollarFreePlayIcon.d20384c1.png";